module.exports = __webpack_public_path__ + "img/背景图.faf5793d.jpg";